import { render } from "./HeaderSectionEditing.vue?vue&type=template&id=cde33b06&ts=true"
import script from "./HeaderSectionEditing.vue?vue&type=script&lang=ts"
export * from "./HeaderSectionEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__